import { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Heading,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { apiClient } from '@/lib/api/client'
import { useThemeColors } from '@/hooks/useThemeColors'

type KBItem = {
  id: number
  ticket_request_id: number | null
  topic: string | null
  solution: string
}

export default function KnowledgePendingPage() {
  const colors = useThemeColors()
  const [items, setItems] = useState<KBItem[]>([])

  const load = () =>
    apiClient.get('/knowledge-base/pending').then((res) => {
      const payload = res.data?.data?.data ?? res.data?.data ?? []
      setItems(Array.isArray(payload) ? payload : [])
    })

  useEffect(() => {
    load()
  }, [])

  const act = async (id: number, action: 'approve' | 'reject') => {
    await apiClient.post(`/knowledge-base/${id}/${action}`)
    load()
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="hidden" display="flex" flexDirection="column">
        <VStack spacing={2} align="stretch" flex="1" overflow="hidden" minH={0}>
          <Card flexShrink={0} display="flex" flexDirection="column" flex="1" minH={0} overflow="hidden">
            <CardHeader flexShrink={0} py={3}>
              <Heading size="md" mb={1}>
                Pending KB Approval
              </Heading>
              <Text fontSize="sm" color={colors.text}>
                Review comments tagged for Knowledge Base publication
              </Text>
            </CardHeader>

            <CardBody p={0} pt={1} pb={4} mx={5} flex="1" overflow="hidden" display="flex" flexDirection="column" minH={0}>
              <TableContainer flex="1" overflowY="auto" border="1px" borderColor={colors.border} borderRadius="md">
                <Table size="sm">
                  <Thead position="sticky" top={0} zIndex={1} bg={colors.cardBg}>
                    <Tr>
                      <Th>Ticket</Th>
                      <Th>Topic</Th>
                      <Th>Solution</Th>
                      <Th>Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {items.length === 0 ? (
                      <Tr>
                        <Td colSpan={4} textAlign="center" py={8} color={colors.textMuted}>
                          No pending KB items.
                        </Td>
                      </Tr>
                    ) : (
                      items.map((item) => (
                        <Tr key={item.id}>
                          <Td>{item.ticket_request_id ?? '—'}</Td>
                          <Td>{item.topic || '—'}</Td>
                          <Td whiteSpace="pre-wrap">{item.solution}</Td>
                          <Td>
                            <HStack>
                              <Button size="xs" colorScheme="green" onClick={() => act(item.id, 'approve')}>
                                Approve
                              </Button>
                              <Button size="xs" colorScheme="red" onClick={() => act(item.id, 'reject')}>
                                Reject
                              </Button>
                            </HStack>
                          </Td>
                        </Tr>
                      ))
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </CardBody>
          </Card>
        </VStack>
      </Box>
    </AdminLayout>
  )
}
